<template>
  <div
    v-if="isFinishCreated"
    class="sp-preview"
    data-test="sp-preview"
  >
    <div
      class="grid-x hide-for-print"
    >
      <div class="cell auto" />
      <print-button />
    </div>
    <preview-job-for-sp
      :job-info="jobInfo"
      :company-interview="companyInterview"
      :company-info="companyInfo"
      :about-apply="aboutApply"
    />
  </div>
</template>

<script>
import PreviewJobForSp from '@/components/organisms/PreviewJobForSp'
import PrintButton from '@/components/atoms/PrintButton'
export default {
  components: {
    PreviewJobForSp,
    PrintButton
  },
  props: {
    edit: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      jobId: '',
      isCompanyStaff: true,
      apiPath: '',
      isFinishCreated: false,
      jobInfo: {},
      companyInterview: {},
      companyInfo: {},
      aboutApply: {},
      codeSetting: {}
    }
  },
  async created () {
    this.$set(this, 'jobId', this.$route.params.jobId)
    this.$set(this, 'isCompanyStaff', (this.$route.name === 'previewJobSp' || this.$route.name === 'confirmPreviewJobSp'))

    // APIをADMとBOSSで分ける
    this.$set(this, 'apiPath',
      this.isCompanyStaff
        ? this.edit
          ? `/preview/edit/jobs/${this.jobId}/`
          : `/preview/confirm/jobs/${this.jobId}/`
        : this.edit
          ? `/preview/edit/companies/${this.$route.params.companyId}/jobs/${this.jobId}/`
          : `/preview/confirm/companies/${this.$route.params.companyId}/jobs/${this.jobId}/`
    )
    this.callApis()
  },
  methods: {
    // create:API呼び出し
    callApis () {
      const query = !this.edit && this.$route.query.folderChildId ? `?folderChildId=${this.$route.query.folderChildId}` : ''
      const apis = [
      // 求人情報取得API
        this.$http.secured.get(this.apiPath + 'job_info' + query),
        // もっと知りたい！会社の素顔API
        this.$http.secured.get(this.apiPath + 'company_interview' + query),
        // 企業情報取得API
        this.$http.secured.get(this.apiPath + 'company_info' + query),
        // 応募について取得API
        this.$http.secured.get(this.apiPath + 'about_apply' + query),
        // コード設定取得API
        this.$http.secured.get(this.apiPath + 'code_settings' + query)
      ]

      Promise.all(apis).then(([
        jobInfoResponse,
        companyInterviewResponse,
        companyInfoResponse,
        aboutApplyResponse,
        codeSettingResponse]) => {
        this.$set(this, 'jobInfo', jobInfoResponse.data)
        this.$set(this, 'companyInterview', companyInterviewResponse.data)
        this.$set(this, 'companyInfo', companyInfoResponse.data)
        this.$set(this, 'aboutApply', aboutApplyResponse.data)
        this.$set(this, 'codeSetting', codeSettingResponse.data)
        this.$set(this, 'isFinishCreated', true)
      })
    }
  }
}
</script>
